import { Global } from '@emotion/react';
import React from 'react';

export const GlobalStyles = () => (
  <Global
    styles={{
      // Chakra relies on a CSS reset to remove the native browser styling from
      // the `ul` elements that toasts are rendered in. Since we're not using a
      // CSS reset, we need to manually reset these styles.
      'ul[id^="chakra-toast-manager-"]': {
        padding: '0 !important',
        margin: '0 !important',
      },
    }}
  />
);
